export default __webpack_public_path__ + "static/pragicts-cloudops-sase-b1969906cc84b4ca5697ce118cb63500.jpg";